import { trackEvent, trackPage } from 'services/analytics';
import { actions, labels } from './index';

export const trackLoadPreferencesCenterPage = (
  hid: string | undefined,
  source: string | undefined,
  unsubscribe_keys: string | undefined,
  subscribe_keys: string | undefined,
) => {
  trackPage('Preferences Center', { hid, source, unsubscribe_keys, subscribe_keys });
};

export const trackUnsubscribeAllClick = () => {
  trackEvent(actions.BUTTON_CLICK, labels.UNSUBSCRIBE_ALL);
};

export const trackDeclineUnsubscribeAllClick = () => {
  trackEvent(actions.BUTTON_CLICK, labels.DECLINE_UNSUBSCRIBE_ALL);
};

export const trackSubscriptionUpdate = (subscribed: boolean, params: Record<string, string | undefined>) => {
  trackEvent(actions.CHECKBOX_CLICK, subscribed ? labels.SUBSCRIBE : labels.UNSUBSCRIBE, params);
};

export const trackDisplayDownForMaintenanceMessage = () => {
  trackEvent(actions.MESSAGE_TEXT, labels.DOWN_FOR_MAINTENANCE);
};

export const trackDisplayEmptySubscriptionListMessage = () => {
  trackEvent(actions.MESSAGE_TEXT, labels.EMPTY_SUB_LIST);
};

export const trackDisplayUserNotFoundMessage = () => {
  trackEvent(actions.MESSAGE_TEXT, labels.USER_NOT_FOUND);
};

export const trackDisplaySuccessUnsubscribeAllBanner = () => {
  trackEvent(actions.BANNER, labels.UNSUBSCRIBE_ALL);
};

export const trackDisplaySuccessUpdatePreferencesBanner = () => {
  trackEvent(actions.BANNER, labels.UPDATE_PREFERENCES);
};

export const trackDisplaySuccessUnsubscribeBanner = (params: Record<string, string | undefined>) => {
  trackEvent(actions.BANNER, labels.UNSUBSCRIBE, params);
};

export const trackDisplaySuccessSubscribeBanner = () => {
  trackEvent(actions.BANNER, labels.SUBSCRIBE);
};

export const trackDisplayFailedToUpdatePreferences = () => {
  trackEvent(actions.ERROR_BANNER, labels.FAILED_TO_UPDATE_PREFERENCES);
};

export const trackNavigateToPreferencesCenterClick = () => {
  trackEvent(actions.BUTTON_CLICK, labels.PREFERENCES_CENTER_NAVIGATION);
};

export const trackAcceptConsentClick = (params: Record<string, string | undefined>) => {
  trackEvent(actions.BUTTON_CLICK, labels.ACCEPT_CONSENT, params);
};

export const trackDeclineConsentClick = (params: Record<string, string | undefined>) => {
  trackEvent(actions.BUTTON_CLICK, labels.DECLINE_CONSENT, params);
};

export const trackDisplayDeclineGmoiConsentBanner = () => {
  trackEvent(actions.ERROR_BANNER, labels.DECLINE_CONSENT);
};

export const trackConfirmConsentPrUnsubClick = (params: Record<string, string | undefined>) => {
  trackEvent(actions.BUTTON_CLICK, labels.CONFIRM_CONSENT_PR_UNSUB_CONSENT, params);
};

export const trackDeclineConsentPrUnsubClick = (params: Record<string, string | undefined>) => {
  trackEvent(actions.BUTTON_CLICK, labels.DECLINE_CONSENT_PR_UNSUB_CONSENT, params);
};

export const trackLanguageToggle = (params: Record<string, string | undefined>) => {
  trackEvent(actions.TOOGLE, labels.SELECT_LANGUAGE, params);
};

export const trackRevokeConsentClick = (params: Record<string, string | undefined>) => {
  trackEvent(actions.CHECKBOX_CLICK, labels.REVOKE_CONSENT, params);
};

export const trackTabSwitch = (params: Record<string, string | undefined>) => {
  trackEvent(actions.TOOGLE, labels.SWITCH_TAB, params);
};

export const trackSubscriptionGroupUpdate = (subscribed: boolean, params: Record<string, string | undefined>) => {
  trackEvent(actions.BUTTON_CLICK, subscribed ? labels.SUBSCRIBE_GROUP : labels.UNSUBSCRIBE_GROUP, params);
};

export const trackRevokeAllConsentClick = () => {
  trackEvent(actions.BUTTON_CLICK, labels.REVOKE_ALL_CONSENT);
};

export const trackDoubleOptInConfirmClick = () => {
  trackEvent(actions.BUTTON_CLICK, labels.CONFIRM_DOUBLE_OPT_IN);
};

export const trackProductInvitationsWarningSubscribeClick = () => {
  trackEvent(actions.BUTTON_CLICK, labels.SUBSCRIBE_PRODUCT_INVITATIONS_WARNING);
};
